export default __webpack_public_path__ + "static/media/tick_2.cc23d4e3.svg";